import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import React from "react";

const FormRadioField = ({ fieldLabel, onChange, radioLabels, value }) => {
  const handleRadioChange = (event, newValue) => {
    // Find the original value from radioLabels to preserve type
    const selectedOption = radioLabels.find(
      label => String(label.value) === String(newValue)
    );
    
    // Pass the original typed value (boolean, string, etc)
    onChange?.(selectedOption ? selectedOption.value : newValue);
  };

  return (
    <FormControl className="mb-3 w-100 Radio-Form-Control">
      <InputLabel className="input-label" shrink>
        {fieldLabel}
      </InputLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        onChange={handleRadioChange}
        value={value}
      >
        <div className="form-control flex">
          {radioLabels.map((radioLabel) => (
            <div key={radioLabel.id}>
              <FormControlLabel
                value={radioLabel.value}
                control={
                  <Radio
                    sx={{
                      color: "rgba(0, 0, 0, 0.54)",
                      "&.Mui-checked": {
                        color: "#2b898b",
                      },
                    }}
                  />
                }
                label={radioLabel.name}
              />
              {radioLabel.image && (
                <img
                  src={radioLabel.image}
                  alt={radioLabel.name}
                  className="radio-image"
                />
              )}
            </div>
          ))}
        </div>
      </RadioGroup>
    </FormControl>
  );
};

export default FormRadioField;